import React from 'react';
import { useDecks } from '@/features/player/PlayerProvider';

const NUDGE = 0.02;

const Crossfader: React.FC = () => {
  const { crossfader, setCrossfader } = useDecks();

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      setCrossfader(crossfader - NUDGE);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      setCrossfader(crossfader + NUDGE);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center gap-3 px-2 py-6 lg:min-w-[9rem]">
      <span className="text-xs font-semibold uppercase tracking-widest text-meradio-dark-light dark:text-text-dark-secondary">
        Crossfader
      </span>
      <div className="flex items-center gap-3 w-full">
        <span className="text-sm font-bold text-meradio-primary">A</span>
        <input
          type="range"
          min={0}
          max={1}
          step={0.01}
          value={crossfader}
          aria-label="Crossfader"
          onChange={(event) => setCrossfader(Number(event.target.value))}
          onKeyDown={handleKeyDown}
          className="crossfader flex-1"
        />
        <span className="text-sm font-bold text-meradio-primary">B</span>
      </div>
    </div>
  );
};

export default Crossfader;
